/**
 * Variant Translations Support
 * 
 * Garante que as traduções nativas do Shopify funcionam corretamente
 * quando variantes são alteradas dinamicamente via JavaScript
 */

(function() {
  'use strict';

  // Detectar idioma atual
  function getCurrentLocale() {
    const htmlLang = document.documentElement.lang || 'pt-PT';
    return htmlLang.toLowerCase();
  }

  // Atualizar valores traduzidos quando variante muda
  function updateTranslatedValues() {
    // Atualizar spans com data-selected-value
    const selectedValueSpans = document.querySelectorAll('[data-selected-value]');
    selectedValueSpans.forEach(span => {
      const variantSelects = span.closest('variant-selects');
      if (!variantSelects) return;

      // Encontrar o valor selecionado atual
      const selectedInput = variantSelects.querySelector('input[type="radio"]:checked, select option:selected');
      if (selectedInput) {
        const label = variantSelects.querySelector(`label[for="${selectedInput.id}"]`);
        if (label) {
          // O texto do label já está traduzido pelo Shopify
          const translatedText = label.textContent.trim();
          // Remover indicadores de indisponível se existirem
          const cleanText = translatedText.replace(/\s*\(.*?indisponível.*?\)/gi, '').trim();
          span.textContent = cleanText;
        }
      }
    });
  }

  // Observar mudanças nas variantes
  function setupVariantTranslationObserver() {
    // Observer para mudanças no DOM
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
          shouldUpdate = true;
        }
        if (mutation.type === 'childList') {
          shouldUpdate = true;
        }
      });
      if (shouldUpdate) {
        setTimeout(updateTranslatedValues, 50);
      }
    });

    // Observar todos os variant-selects
    document.querySelectorAll('variant-selects').forEach(variantSelects => {
      observer.observe(variantSelects, {
        attributes: true,
        attributeFilter: ['checked', 'selected'],
        childList: true,
        subtree: true
      });
    });

    // Também escutar eventos de mudança
    document.addEventListener('change', (e) => {
      if (e.target.closest('variant-selects')) {
        setTimeout(updateTranslatedValues, 50);
      }
    });
  }

  // Escutar eventos de mudança de variante
  function setupVariantChangeListener() {
    if (typeof subscribe === 'function') {
      const variantChangeEvent = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) 
        ? PUB_SUB_EVENTS.variantChange 
        : 'variant-change';
      
      subscribe(variantChangeEvent, () => {
        setTimeout(updateTranslatedValues, 100);
        // Reajustar alturas sem resetar para evitar efeito visual
        setTimeout(() => equalizeCardHeights(false), 150);
      });
    }
    
    // Também escutar mudanças diretas de radio
    document.addEventListener('change', (e) => {
      if (e.target.type === 'radio' && e.target.closest('variant-selects')) {
        setTimeout(() => equalizeCardHeights(false), 100);
      }
    });
  }

  // Adicionar classe ao fieldset quando há cards com múltiplos sabores ou apenas simples
  function setupMultiFlavorGrid() {
    document.querySelectorAll('.product-form__input--pill').forEach(fieldset => {
      const hasMultiFlavor = fieldset.querySelector('input[data-multiple-flavors="true"]');
      const hasSingleFlavor = fieldset.querySelector('input[data-single-flavor="true"]');
      
      if (hasMultiFlavor) {
        fieldset.classList.add('has-multi-flavor-cards');
        fieldset.classList.remove('has-single-flavor-cards');
      } else if (hasSingleFlavor) {
        fieldset.classList.add('has-single-flavor-cards');
        fieldset.classList.remove('has-multi-flavor-cards');
      }
    });
  }

  // Garantir que todos os cards tenham o mesmo tamanho
  function equalizeCardHeights(resetHeights = true) {
    document.querySelectorAll('.product-form__input--pill').forEach(fieldset => {
      const labels = Array.from(fieldset.querySelectorAll('label.variant-label--multi-flavor'));
      if (labels.length === 0) return;

      // Calcular altura máxima primeiro (sem resetar se resetHeights = false)
      let maxHeight = 0;
      labels.forEach(label => {
        if (resetHeights) {
          label.style.setProperty('height', 'auto', 'important');
        }
        // Forçar recálculo do layout
        label.offsetHeight;
        const height = label.getBoundingClientRect().height;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      // Usar requestAnimationFrame para aplicar altura de forma suave
      requestAnimationFrame(() => {
        // Aplicar altura máxima a todos os cards usando !important
        if (maxHeight > 0) {
          labels.forEach(label => {
            label.style.setProperty('height', maxHeight + 'px', 'important');
          });
        }
      });
    });
  }

  // Prevenir scroll automático quando variante é selecionada
  function preventAutoScroll() {
    // Guardar posição de scroll antes de mudanças
    let scrollPosition = window.scrollY || window.pageYOffset;

    // Prevenir scroll quando input recebe focus
    document.addEventListener('focusin', (e) => {
      const radioInput = e.target;
      if (radioInput && radioInput.type === 'radio' && radioInput.closest('variant-selects')) {
        // Restaurar posição de scroll imediatamente após focus
        requestAnimationFrame(() => {
          window.scrollTo({
            top: scrollPosition,
            behavior: 'instant'
          });
        });
      }
    }, true);

    // Guardar posição de scroll antes de mudanças
    document.addEventListener('change', (e) => {
      if (e.target.type === 'radio' && e.target.closest('variant-selects')) {
        scrollPosition = window.scrollY || window.pageYOffset;
        // Prevenir scroll após mudança
        requestAnimationFrame(() => {
          const currentScroll = window.scrollY || window.pageYOffset;
          if (Math.abs(currentScroll - scrollPosition) > 10) {
            window.scrollTo({
              top: scrollPosition,
              behavior: 'instant'
            });
          }
        });
      }
    }, true);

    // Também prevenir scroll quando label é clicado
    document.addEventListener('click', (e) => {
      const label = e.target.closest('label[for]');
      if (label) {
        const inputId = label.getAttribute('for');
        const radioInput = document.getElementById(inputId);
        if (radioInput && radioInput.type === 'radio' && radioInput.closest('variant-selects')) {
          scrollPosition = window.scrollY || window.pageYOffset;
          // Prevenir scroll após um pequeno delay
          setTimeout(() => {
            const currentScroll = window.scrollY || window.pageYOffset;
            if (Math.abs(currentScroll - scrollPosition) > 10) {
              window.scrollTo({
                top: scrollPosition,
                behavior: 'instant'
              });
            }
          }, 10);
        }
      }
    }, true);
  }

  // Inicializar quando DOM estiver pronto
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        updateTranslatedValues();
        setupVariantTranslationObserver();
        setupVariantChangeListener();
        setupMultiFlavorGrid();
        preventAutoScroll();
        // Aguardar um pouco mais para garantir que tudo carregou
        setTimeout(equalizeCardHeights, 300);
        // Executar novamente após imagens carregarem
        window.addEventListener('load', () => {
          setTimeout(equalizeCardHeights, 100);
        });
      });
    } else {
      updateTranslatedValues();
      setupVariantTranslationObserver();
      setupVariantChangeListener();
      setupMultiFlavorGrid();
      preventAutoScroll();
      setTimeout(equalizeCardHeights, 300);
      // Executar novamente após imagens carregarem
      if (document.readyState === 'complete') {
        setTimeout(equalizeCardHeights, 100);
      } else {
        window.addEventListener('load', () => {
          setTimeout(equalizeCardHeights, 100);
        });
      }
    }

    // Re-executar quando sections são recarregadas (Shopify theme editor)
    document.addEventListener('shopify:section:load', () => {
      setTimeout(() => {
        updateTranslatedValues();
        setupVariantTranslationObserver();
        setupMultiFlavorGrid();
        preventAutoScroll();
        equalizeCardHeights();
      }, 200);
    });

    // Re-executar quando janela é redimensionada
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        equalizeCardHeights();
      }, 250);
    });

    // Re-executar quando imagens são carregadas
    document.addEventListener('load', (e) => {
      if (e.target.tagName === 'IMG' && e.target.closest('.variant-label--multi-flavor')) {
        setTimeout(equalizeCardHeights, 100);
      }
    }, true);
  }

  init();
})();

